import { useLayoutEffect } from 'react';

// Module-level refs to support nested locks (multiple overlays)
let lockCount = 0;
let savedScrollY = 0;
let originalOverflow = '';
let originalPaddingRight = '';
let originalPosition = '';
let originalTop = '';
let originalScrollBehavior = '';

const getScrollbarWidth = () => {
  if (typeof window === 'undefined') return 0;
  return window.innerWidth - document.documentElement.clientWidth;
};

export const useScrollLock = (isLocked: boolean) => {
  useLayoutEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    if (!isLocked) return;

    // Lock logic
    const lock = () => {
      if (lockCount === 0) {
        savedScrollY = window.scrollY || window.pageYOffset;
        const body = document.body;
        const html = document.documentElement;
        originalOverflow = body.style.overflow;
        originalPaddingRight = body.style.paddingRight;
        originalPosition = body.style.position;
        originalTop = body.style.top;
        originalScrollBehavior = document.documentElement.style.scrollBehavior;

        const scrollbarWidth = getScrollbarWidth();
        if (scrollbarWidth > 0) {
          body.style.paddingRight = `${scrollbarWidth}px`;
        }

        // iOS Safari needs position fixed to prevent rubber-band scrolling
        body.style.position = 'fixed';
        body.style.top = `-${savedScrollY}px`;
        body.style.width = '100%';
        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
      }
      lockCount += 1;
    };

    // Unlock logic
    const unlock = () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        const body = document.body;
        const html = document.documentElement;
        const scrollTarget = Math.abs(parseInt(body.style.top || '0', 10)) || savedScrollY;

        // 强制禁用平滑滚动，避免恢复位置时的动画跳变
        html.style.scrollBehavior = 'auto';

        body.style.overflow = originalOverflow;
        body.style.paddingRight = originalPaddingRight;
        body.style.position = originalPosition;
        body.style.top = originalTop;
        body.style.width = '';
        html.style.overflow = '';

        // Force reflow to ensure browser calculates layout before scrolling
        // This prevents the page from jumping to top if layout isn't ready
        void document.body.offsetHeight;

        // Restore scroll position immediately
        window.scrollTo(0, scrollTarget);

        // 恢复原始滚动行为
        html.style.scrollBehavior = originalScrollBehavior;
      }
    };

    lock();
    return () => unlock();
  }, [isLocked]);
};
